export default {
  nav: {
    home: "Trang chủ",
    aboutUs: "Giới thiệu",
    products: "Sản phẩm",
    quality: "Chất lượng",
    sustainability: "Phát triển bền vững",
    globalReach: "Thị trường",
    contact: "Liên hệ",
  },
  quick: {
    whatsapp: "WhatsApp",
    zalo: "Zalo",
    wechat: "WeChat",
    qrTitle: "Kết nối với chúng tôi qua {{app}}",
    qrDesc:
      "Quét mã QR bên dưới bằng {{app}} để trò chuyện trực tiếp với đội ngũ xuất khẩu của chúng tôi.",
    qrPlaceholder: "Mã QR {{app}}",
    qrStepsTitle: "Hướng dẫn quét mã",
    qrStep1: "Mở {{app}} trên điện thoại và vào màn hình quét mã.",
    qrStep2:
      "Hướng camera vào mã QR bên dưới để mở trang liên hệ của chúng tôi.",
    qrStep3:
      "Gửi tin nhắn cho chúng tôi — đội ngũ sẽ phản hồi trong vòng một ngày làm việc.",
    qrClose: "Đóng",
    callNow: "Gọi ngay",
    callTitle: "Gọi cho đội ngũ của chúng tôi",
    callDesc:
      "Gọi trực tiếp cho bộ phận xuất khẩu — chúng tôi sẵn sàng tư vấn trong giờ làm việc.",
    callLabel: "Số điện thoại",
    callCopy: "Sao chép số",
    callCopied: "Đã sao chép",
    callClose: "Đóng",
    open: "Mở liên hệ nhanh",
    close: "Đóng liên hệ nhanh",
  },
  footer: {
    heading: "Cùng nhau vun đắp\nmột tương lai tươi sáng hơn",
    cta: "Liên hệ ngay",
    rights: "© 2026 EverRice. Bảo lưu mọi quyền.",
    email: "info@everrice.vn",
    location: "TP. Hồ Chí Minh, Việt Nam",
    company: "EverRice Company Limited",
  },
  home: {
    hero: {
      eyebrow: "ĐỐI TÁC TIN CẬY CỦA BẠN",
      title: "Đưa gạo Việt Nam vươn ra thế giới",
      sub1: "Chất lượng cao. Phát triển bền vững.",
      sub2: "Chung tay kiến tạo tương lai tốt đẹp hơn cho con người và cộng đồng.",
      cta: "Sản phẩm của chúng tôi",
    },
    about: {
      eyebrow: "Về EverRice",
      title1: "Bắt nguồn từ Việt Nam",
      title2: "Vươn tầm ra thế giới",
      desc: "Chúng tôi là doanh nghiệp xuất khẩu gạo Việt Nam, cam kết mang gạo chất lượng cao đến các thị trường toàn cầu, đồng thời tạo ra giá trị bền vững cho nông dân, đối tác và cộng đồng.",
      cta: "Tìm hiểu thêm",
      features: [
        {
          title: "Chất lượng vượt trội",
          desc: "Tuyển chọn kỹ lưỡng từ những vùng đất phù sa",
        },
        {
          title: "Cung ứng toàn cầu",
          desc: "Được các đối tác trên toàn thế giới tin tưởng",
        },
        {
          title: "Phát triển bền vững",
          desc: "Vì con người, cộng đồng và môi trường",
        },
      ],
    },
    products: {
      eyebrow: "Sản phẩm của chúng tôi",
      title: "Tinh hoa gạo Việt - Kiến tạo tương lai tốt đẹp",
      desc: "Từ những dòng gạo thơm thượng hạng đến gạo trắng tuyển chọn, gạo nếp và các giống gạo đặc sản, EverRice tự hào đưa tinh hoa gạo Việt vươn xa, hiện diện trên bàn ăn khắp năm châu.",
      cta: "Xem sản phẩm",
      items: [
        { name: "Gạo thơm", desc: "Hương thơm thanh tao và tinh tế" },
        { name: "Gạo trắng", desc: "Chất lượng ổn định" },
        { name: "Gạo nếp", desc: "Giàu dinh dưỡng" },
        { name: "Gạo đặc sản", desc: "Chủng loại độc đáo" },
      ],
    },
    stats: [
      { value: "15+", label: "Quốc gia xuất khẩu" },
      { value: "200k", label: "Tấn xuất khẩu mỗi năm" },
      { value: "40k", label: "Tấn năng lực cung ứng mỗi tháng" },
      { value: "14", label: "Năm kinh nghiệm" },
    ],
    globalReach: {
      eyebrow: "Thị trường",
      title: "Từ Việt Nam vươn ra thế giới",
      desc: "Chúng tôi cung cấp gạo chất lượng cao đến các thị trường khắp châu Á, Bắc Mỹ, châu Âu, châu Phi và nhiều khu vực khác.",
      cta: "Thị trường của chúng tôi",
    },
    sustainability: {
      eyebrow: "Phát triển bền vững",
      title: "Vun đắp hôm nay\ncho thế hệ mai sau",
      desc: "Chúng tôi hợp tác chặt chẽ với nông dân, thúc đẩy canh tác bền vững và đóng góp cho một tương lai xanh, khỏe mạnh hơn.",
      cta: "Cam kết của chúng tôi",
      features: [
        { title: "Đồng hành cùng nông dân" },
        { title: "Trách nhiệm với môi trường" },
        { title: "Cộng đồng vững mạnh" },
      ],
    },
  },
  aboutPage: {
    hero: {
      eyebrow: "VỀ EVERRICE",
      title: "Bắt nguồn từ Việt Nam, vươn tầm ra thế giới",
      desc: "Một doanh nghiệp xuất khẩu gạo Việt Nam đáng tin cậy, cam kết về chất lượng, sự chính trực và quan hệ đối tác lâu dài với nông dân và nhà nhập khẩu gạo trên khắp thế giới.",
    },
    story: {
      eyebrow: "Câu chuyện của chúng tôi",
      title: "Từ một nhà xuất khẩu gạo nhỏ đến đối tác toàn cầu đáng tin cậy",
      p1: "EverRice được xây dựng từ niềm tin vào chất lượng, sự chính trực và giá trị của những mối quan hệ bền vững. Qua từng chuyến hàng, chúng tôi không ngừng vun đắp niềm tin cùng người nông dân và đối tác trên hành trình đưa gạo Việt vươn xa.",
      p2: "Ngày nay, EverRice kết nối tinh hoa gạo Việt với các nhà nhập khẩu trên toàn thế giới. Dù không ngừng phát triển, chúng tôi vẫn kiên định với những giá trị cốt lõi: chất lượng đáng tin cậy, sự chính trực và quan hệ đối tác bền vững.",
      ctaProducts: "Sản phẩm của chúng tôi",
      ctaContact: "Liên hệ",
    },
    pillars: {
      eyebrow: "Điều dẫn dắt chúng tôi",
      title: "Sứ mệnh, Tầm nhìn & Giá trị",
      items: [
        {
          title: "Sứ mệnh",
          desc: "Mang gạo Việt Nam cao cấp đến thế giới, đồng thời xây dựng quan hệ đối tác lâu dài với nông dân và nhà nhập khẩu gạo trên toàn thế giới.",
        },
        {
          title: "Tầm nhìn",
          desc: "Trở thành đối tác gạo Việt Nam đáng tin cậy nhất trên các thị trường toàn cầu, nổi bật nhờ chất lượng và sự chính trực.",
        },
        {
          title: "Giá trị",
          desc: "Chất lượng vượt trội. Phát triển bền vững. Chính trực. Hợp tác chân thành. Tôn trọng lẫn nhau.",
        },
      ],
    },
    values: {
      eyebrow: "Giá trị cốt lõi",
      title: "Những nguyên tắc dẫn dắt chúng tôi",
      items: [
        {
          title: "Chất lượng vượt trội",
          desc: "Chúng tôi không bao giờ thỏa hiệp về chất lượng của những gì mình mang đến.",
        },
        {
          title: "Phát triển bền vững",
          desc: "Chúng tôi xây dựng để thành công lâu dài, tạo giá trị cho đối tác và cộng đồng mà chúng tôi đồng hành.",
        },
        {
          title: "Chính trực",
          desc: "Chúng tôi làm điều đúng đắn, giữ lời hứa và chịu trách nhiệm cho hành động của mình.",
        },
        {
          title: "Hợp tác chân thành",
          desc: "Chúng tôi tin rằng những mối quan hệ kinh doanh bền vững được xây dựng trên sự minh bạch, niềm tin và thành công chung.",
        },
        {
          title: "Tôn trọng",
          desc: "Chúng tôi trân trọng nông dân, đối tác, khách hàng và mọi người đóng góp vào hành trình của chúng tôi.",
        },
      ],
    },
    facilities: {
      eyebrow: "Đằng sau mỗi hạt gạo",
      title: "Từ ruộng đồng đến bến cảng",
      sub: "Chuỗi cung ứng có thể truy xuất đầy đủ — Thu mua, xay xát và kiểm nghiệm.",
      items: [
        { title: "Thu mua từ đồng bằng sông Cửu Long" },
        { title: "Xay xát tại nhà máy hiện đại" },
        { title: "Kiểm nghiệm bởi phòng lab đạt chuẩn" },
      ],
    },
    stats: [
      { value: "14", label: "Năm kinh nghiệm" },
      { value: "15+", label: "Quốc gia xuất khẩu" },
      { value: "40k", label: "Tấn năng lực cung ứng mỗi tháng" },
      { value: "200k", label: "Tấn xuất khẩu mỗi năm" },
    ],
  },
  productsPage: {
    hero: {
      eyebrow: "SẢN PHẨM CỦA CHÚNG TÔI",
      title: "Tinh hoa gạo Việt\nKiến tạo tương lai tốt đẹp",
      desc: "Từ những dòng gạo thơm tinh túy đến gạo trắng chất lượng cao, gạo nếp và các loại gạo đặc sản, chúng tôi tự hào đưa những hạt gạo Việt Nam tinh túy nhất đến bàn ăn trên khắp thế giới.",
    },
    grid: {
      categories: [
        { key: "all", label: "Tất cả sản phẩm" },
        { key: "fragrant", label: "Gạo thơm" },
        { key: "white", label: "Gạo trắng" },
        { key: "brown", label: "Gạo nếp" },
        { key: "specialty", label: "Gạo đặc sản" },
      ],
      labels: {
        grade: "Chiều dài hạt",
        packing: "Đóng gói",
        moisture: "Độ ẩm",
      },
      items: [
        {
          cat: "fragrant",
          name: "Gạo jasmine",
          desc: "Mềm, thơm và ngọt tự nhiên — dòng gạo dài kiểu jasmine Thái đặc trưng của chúng tôi.",
          grade: "Cao cấp 5% tấm",
          packaging: "1kg / 5kg / 25kg / 50kg",
          moisture: "Tối đa 14%",
        },
        {
          cat: "fragrant",
          name: "Gạo dài thơm",
          desc: "Mùi lá dứa dịu nhẹ với kết cấu nhẹ, tơi xốp và vẫn mềm sau khi nấu.",
          grade: "Cao cấp 5% tấm",
          packaging: "5kg / 10kg / 25kg",
          moisture: "Tối đa 14%",
        },
        {
          cat: "fragrant",
          name: "Gạo ST25",
          desc: "Dòng gạo dài cao cấp từng đoạt giải, hạt mềm, ngọt tự nhiên và thơm dịu.",
          grade: "Cao cấp 5% tấm",
          packaging: "1kg / 5kg / 25kg",
          moisture: "Tối đa 14%",
        },
        {
          cat: "fragrant",
          name: "Gạo Nàng Hoa",
          desc: "Hạt gạo dài thon, nổi bật với hương hoa nhẹ nhàng và độ mềm vừa phải.",
          grade: "Cao cấp 5% tấm",
          packaging: "5kg / 10kg / 25kg",
          moisture: "Tối đa 14%",
        },
        {
          cat: "white",
          name: "Gạo trắng 5%",
          desc: "Chuẩn mực thường ngày — sạch, đồng nhất, lý tưởng cho bữa ăn hằng ngày và dịch vụ ăn uống.",
          grade: "5% tấm",
          packaging: "10kg / 25kg / 50kg",
          moisture: "Tối đa 14%",
        },
        {
          cat: "white",
          name: "Gạo trắng 15%",
          desc: "Phẩm cấp giá trị đáng tin cậy cho dịch vụ ăn uống, chế biến và khách hàng số lượng lớn.",
          grade: "15% tấm",
          packaging: "25kg / 50kg",
          moisture: "Tối đa 14%",
        },
        {
          cat: "white",
          name: "Gạo trắng 10%",
          desc: "Phẩm cấp cân bằng cho bữa ăn hằng ngày — sạch, mịn và được đánh bóng kỹ.",
          grade: "10% tấm",
          packaging: "25kg / 50kg",
          moisture: "Tối đa 14%",
        },
        {
          cat: "white",
          name: "Gạo Nhật",
          desc: "Hạt ngắn, tròn, dẻo bóng — lý tưởng cho sushi và các món ăn Nhật Bản.",
          grade: "Hạt ngắn",
          packaging: "1kg / 5kg / 25kg",
          moisture: "Tối đa 14%",
        },
        {
          cat: "brown",
          name: "Gạo lứt",
          desc: "Nguyên hạt còn giữ lớp cám — bùi, lành mạnh và giàu chất xơ.",
          grade: "Nguyên hạt",
          packaging: "1kg / 5kg / 25kg",
          moisture: "Tối đa 14,5%",
        },
        {
          cat: "brown",
          name: "Gạo đỏ",
          desc: "Lớp cám đỏ đặc trưng với độ dai chắc và hương vị ấm, mộc mạc.",
          grade: "Nguyên hạt",
          packaging: "1kg / 5kg / 25kg",
          moisture: "Tối đa 14,5%",
        },
        {
          cat: "brown",
          name: "Gạo nếp trắng",
          desc: "Hạt nếp bóng, mềm và dẻo tự nhiên — lựa chọn cổ điển cho món lễ và tráng miệng.",
          grade: "Nguyên hạt",
          packaging: "1kg / 5kg / 25kg",
          moisture: "Tối đa 14,5%",
        },
        {
          cat: "brown",
          name: "Gạo nếp lá dứa",
          desc: "Gạo nếp thơm với sắc xanh dịu và hương lá dứa nhẹ nhàng.",
          grade: "Nguyên hạt",
          packaging: "1kg / 5kg / 25kg",
          moisture: "Tối đa 14,5%",
        },
        {
          cat: "specialty",
          name: "Gạo nếp đen",
          desc: "Bóng, ngọt tự nhiên và dẻo — lựa chọn yêu thích cho các món tráng miệng truyền thống.",
          grade: "Nguyên hạt",
          packaging: "1kg / 5kg / 25kg",
          moisture: "Tối đa 14,5%",
        },
        {
          cat: "specialty",
          name: "Jasmine hữu cơ",
          desc: "Đạt chứng nhận hữu cơ, trồng không dùng thuốc trừ sâu tổng hợp cho bàn ăn sạch nhất.",
          grade: "Chứng nhận hữu cơ",
          packaging: "1kg / 5kg",
          moisture: "Tối đa 14%",
        },
        {
          cat: "specialty",
          name: "Gạo mầm",
          desc: "Gạo lứt nảy mầm giàu GABA — thêm dưỡng chất với kết cấu mềm và hạt bùi hơn.",
          grade: "Gạo mầm",
          packaging: "1kg / 5kg",
          moisture: "Tối đa 14%",
        },
        {
          cat: "specialty",
          name: "Gạo huyết rồng",
          desc: "Dòng gạo đỏ quý với màu đỏ thẫm đặc trưng và độ dai chắc, bùi vị.",
          grade: "Nguyên hạt",
          packaging: "1kg / 5kg / 25kg",
          moisture: "Tối đa 14,5%",
        },
      ],
    },
    certs: {
      eyebrow: "Đảm bảo chất lượng",
      title: "Đạt chuẩn ở mọi công đoạn",
      desc: "Mỗi lô gạo đều được kiểm tra độ tinh khiết, độ ẩm và an toàn thực phẩm trước khi rời nhà máy.",
      items: [
        { title: "HACCP", desc: "Đạt chứng nhận quản lý an toàn thực phẩm" },
        { title: "ISO 22000", desc: "Tiêu chuẩn an toàn thực phẩm toàn cầu" },
        { title: "Hữu cơ", desc: "Các giống gạo đạt chứng nhận hữu cơ" },
        { title: "GLOBALG.A.P.", desc: "Thực hành canh tác có trách nhiệm" },
      ],
    },
    packaging: {
      eyebrow: "Lựa chọn linh hoạt",
      title: "Đóng gói cho mọi khách hàng",
      items: [
        {
          title: "Gói bán lẻ",
          desc: "Túi 1kg, 2kg và 5kg sẵn sàng cho siêu thị và thương mại điện tử.",
        },
        {
          title: "Bao số lượng lớn",
          desc: "Bao PP dệt hoặc bao giấy 25kg và 50kg cho nhà phân phối và chế biến.",
        },
        {
          title: "Nguyên container",
          desc: "Vận chuyển nguyên container 20ft và 40ft với điều khoản FCL và LCL linh hoạt.",
        },
      ],
      box: {
        title: "Cần một quy cách riêng?",
        desc: "Cho chúng tôi biết phẩm cấp, sản lượng và điểm đến — chúng tôi sẽ chuẩn bị báo giá riêng.",
        cta: "Yêu cầu báo giá",
      },
    },
  },
  qualityPage: {
    hero: {
      eyebrow: "ĐẢM BẢO CHẤT LƯỢNG",
      title: "Chất lượng đong đầy trong từng hạt gạo",
      desc: "Tiêu chuẩn nhất quán, kiểm định nghiêm ngặt và khả năng truy xuất nguồn gốc đầy đủ — đó là cách chúng tôi xây dựng niềm tin với khách hàng tại hơn 15 quốc gia.",
    },
    intro: {
      eyebrow: "Cam kết của chúng tôi",
      title: "Những tiêu chuẩn chúng tôi luôn giữ vững",
      desc: "Chất lượng gạo được tạo nên từ khâu tuyển chọn nguyên liệu kỹ lưỡng, quy trình xay xát chuẩn xác và kiểm soát nghiêm ngặt ở từng công đoạn. Mỗi lô hàng đều được kiểm tra chặt chẽ, bảo đảm chất lượng đồng nhất và đáp ứng kỳ vọng của đối tác.",
      highlights: [
        {
          title: "Kiểm nghiệm từng lô trong phòng lab",
          desc: "Mỗi lô đều được lấy mẫu và phân tích độ ẩm, độ tinh khiết và hạt gãy trước khi phê duyệt.",
        },
        {
          title: "Truy xuất nguồn gốc đầy đủ",
          desc: "Từ vùng nguyên liệu đến từng container xuất khẩu, mọi công đoạn đều được ghi nhận minh bạch và có thể truy xuất.",
        },
        {
          title: "Tiêu chuẩn đạt chứng nhận",
          desc: "Hoạt động phù hợp với các khuôn khổ an toàn thực phẩm HACCP, ISO 22000 và GLOBALG.A.P.",
        },
      ],
    },
    process: {
      eyebrow: "Quy trình của chúng tôi",
      title: "Năm bước kiểm soát - Một chuẩn mực chất lượng.",
      items: [
        {
          step: "01",
          title: "LỰA CHỌN VÙNG TRỒNG",
          desc: "Chúng tôi tuyển chọn lúa nguyên liệu từ các nông trại đối tác tại những vùng trồng được chứng nhận, với khả năng truy xuất nguồn gốc đến từng thửa ruộng.",
        },
        {
          step: "02",
          title: "Xay xát có kiểm soát",
          desc: "Nhà máy hiện đại với công đoạn bóc vỏ và đánh bóng được hiệu chỉnh để đạt độ xay đồng nhất.",
        },
        {
          step: "03",
          title: "Kiểm nghiệm phòng lab",
          desc: "Mẫu được kiểm tra độ ẩm, hạt gãy, tạp chất và các chỉ tiêu an toàn thực phẩm.",
        },
        {
          step: "04",
          title: "Đóng gói chính xác",
          desc: "Bao bì sạch, đạt chuẩn thực phẩm trong điều kiện kiểm soát, được niêm phong và dán nhãn theo đơn hàng.",
        },
        {
          step: "05",
          title: "HỒ SƠ CHỨNG TỪ LÔ HÀNG",
          desc: "Mỗi lô hàng đều đi kèm chứng nhận chất lượng và phiếu phân tích, đảm bảo tính minh bạch trong suốt quá trình giao nhận.",
        },
      ],
    },
    specs: {
      eyebrow: "Tiêu chuẩn kỹ thuật",
      title: "Những gì chúng tôi đo lường",
      sub: "Thông số xuất khẩu điển hình. Chỉ tiêu cuối cùng được thống nhất với từng khách hàng theo hợp đồng.",
      head: {
        param: "Chỉ tiêu",
        standard: "Tiêu chuẩn",
        method: "Phương pháp kiểm tra",
      },
      rows: [
        { param: "Độ ẩm", standard: "Tối đa 14,0%", method: "ISO 712" },
        {
          param: "Hạt gãy",
          standard: "5% / 15% theo phẩm cấp",
          method: "ISO 7301",
        },
        {
          param: "Tạp chất",
          standard: "Tối đa 0,10%",
          method: "Quan sát & sàng",
        },
        {
          param: "Hạt lúa",
          standard: "Tối đa 5 hạt / kg",
          method: "Đếm thủ công",
        },
        {
          param: "Độ xay xát",
          standard: "Xay kỹ",
          method: "Đánh giá cảm quan",
        },
        {
          param: "Chỉ số độ trắng",
          standard: "40+",
          method: "Máy đo độ trắng",
        },
      ],
    },
    labs: {
      eyebrow: "Hậu trường",
      title: "Nơi chất lượng được tạo nên",
      items: [
        { title: "Kiểm tra hạt gạo" },
        { title: "Phòng kiểm nghiệm" },
        { title: "Kho bảo quản có kiểm soát" },
      ],
    },
    certs: {
      eyebrow: "Được công nhận toàn cầu",
      title: "Chứng nhận ở mỗi công đoạn",
      desc: "Các cuộc đánh giá độc lập và chứng nhận được công nhận rộng rãi là cơ sở bảo chứng cho những tiêu chuẩn mà chúng tôi cam kết với đối tác.",
      items: [
        {
          title: "HACCP",
          desc: "Phân tích mối nguy và điểm kiểm soát tới hạn",
        },
        { title: "ISO 22000", desc: "Quản lý an toàn thực phẩm toàn cầu" },
        { title: "Hữu cơ", desc: "Các giống gạo đạt chứng nhận hữu cơ" },
        { title: "GLOBALG.A.P.", desc: "Thực hành canh tác có trách nhiệm" },
      ],
    },
    stats: [
      { value: "100%", label: "Lô được kiểm nghiệm" },
      { value: "24h", label: "Thời gian kiểm nghiệm trung bình" },
      { value: "0,1%", label: "Tạp chất tối đa" },
      { value: "5", label: "Điểm kiểm tra chất lượng" },
    ],
    cta: {
      title: "Yêu cầu hồ sơ chất lượng",
      desc: "Thông số kỹ thuật, giấy chứng nhận phân tích và báo cáo kiểm định đều có sẵn cho mỗi đơn hàng. Hãy cho chúng tôi biết yêu cầu của bạn và chúng tôi sẽ chuẩn bị đầy đủ.",
      ctaContact: "Liên hệ",
      ctaProducts: "Sản phẩm của chúng tôi",
    },
  },
  sustainabilityPage: {
    hero: {
      eyebrow: "PHÁT TRIỂN BỀN VỮNG",
      title: "Phát triển trách nhiệm, gặt hái tương lai",
      desc: "Chúng tôi tin rằng chất lượng gạo song hành với trách nhiệm môi trường. Mỗi mùa vụ là một cơ hội để gìn giữ đất đai, nâng cao giá trị lao động người nông dân và xây dựng cộng đồng phát triển bền vững.",
    },
    intro: {
      eyebrow: "Triết lý của chúng tôi",
      title: "Vun đắp hôm nay cho thế hệ mai sau",
      p1: "Chúng tôi đồng hành cùng người trồng lúa trong canh tác bền vững, bảo vệ tài nguyên và nâng cao sinh kế.",
      p2: "Từ ruộng đồng đến nhà máy, EverRice hướng đến giảm lãng phí, tối ưu năng lượng và minh bạch chuỗi cung ứng, để mỗi hạt gạo mang giá trị bền vững hơn.",
      ctaQuality: "Chất lượng của chúng tôi",
      ctaWork: "Hợp tác cùng chúng tôi",
    },
    pillars: {
      eyebrow: "Giá Trị Chúng Tôi Gìn Giữ",
      title: "Ba trụ cột trong cam kết của chúng tôi",
      items: [
        {
          title: "Đồng hành cùng nông dân",
          desc: "Giá cả minh bạch, hợp tác dài hạn và chia sẻ kiến thức giúp người nông dân nâng cao sinh kế, hướng đến tương lai bền vững.",
        },
        {
          title: "Trách nhiệm với môi trường",
          desc: "Tưới tiêu tiết kiệm nước, canh tác hữu cơ và ứng dụng năng lượng tái tạo trong sản xuất.",
        },
        {
          title: "Cộng đồng vững mạnh",
          desc: "Góp phần phát triển cộng đồng thông qua giáo dục, nước sạch và mở rộng cơ hội tại những vùng trồng lúa.",
        },
      ],
    },
    initiatives: {
      eyebrow: "Hành động thực tế",
      title: "Các sáng kiến xuyên suốt chuỗi cung ứng",
      sub: "Những chương trình cụ thể giúp gạo của chúng tôi tốt hơn cho con người và hành tinh.",
      items: [
        {
          title: "Tưới tiêu tiết kiệm nước",
          desc: "Kỹ thuật tưới ướt – khô xen kẽ giúp giảm lượng nước sử dụng mà vẫn giữ năng suất cao.",
        },
        {
          title: "Canh tác hữu cơ",
          desc: "Giảm hóa chất đầu vào và chăm sóc đất tự nhiên để có những cánh đồng khỏe mạnh, sạch hơn.",
        },
        {
          title: "Giá cả công bằng",
          desc: "Hợp đồng minh bạch mang lại thu nhập ổn định và công bằng cho nông dân.",
        },
        {
          title: "Đào tạo nông dân",
          desc: "Các lớp học hiện trường dạy kỹ thuật hiện đại, bền vững cho nông dân đối tác.",
        },
        {
          title: "Năng lượng tái tạo",
          desc: "Điện mặt trời và sinh khối giúp giảm dấu chân carbon của hoạt động xay xát.",
        },
        {
          title: "Giảm lãng phí",
          desc: "Trấu và cám được tái sử dụng làm nhiên liệu sinh khối và thức ăn chăn nuôi thay vì bỏ đi.",
        },
      ],
    },
    goals: {
      eyebrow: "Mục tiêu đến 2030",
      title: "Nơi chúng tôi đang hướng tới",
      items: [
        {
          value: "100%",
          label: "Gạo có nguồn gốc có trách nhiệm",
          desc: "Toàn bộ gạo được thu mua từ nông dân bền vững đạt chứng nhận vào năm 2030.",
        },
        {
          value: "30%",
          label: "Giảm lượng nước sử dụng",
          desc: "Giảm nước tưới cho mỗi tấn lúa tại các nông trại đối tác.",
        },
        {
          value: "50%",
          label: "Năng lượng tái tạo",
          desc: "Một nửa năng lượng xay xát đến từ nguồn mặt trời và sinh khối.",
        },
        {
          value: "20.000",
          label: "Nông dân được đào tạo",
          desc: "Mở rộng chương trình giáo dục canh tác bền vững của chúng tôi.",
        },
      ],
    },
    stats: [
      { value: "12.000", label: "Nông dân đồng hành được hỗ trợ" },
      { value: "4.500 ha", label: "Diện tích canh tác bền vững" },
      { value: "30%", label: "Nước tiết kiệm mỗi vụ" },
      { value: "18", label: "Năm cùng nhau phát triển" },
    ],
    cta: {
      title: "Cùng chúng tôi tạo nên điều tốt đẹp hơn",
      desc: "Cùng EverRice nâng tầm chất lượng gạo, vun đắp giá trị con người và kiến tạo tương lai bền vững.",
      ctaContact: "Liên hệ",
      ctaProducts: "Sản phẩm của chúng tôi",
    },
  },
  globalReachPage: {
    hero: {
      eyebrow: "THỊ TRƯỜNG TOÀN CẦU",
      title: "Từ Việt Nam vươn ra thế giới",
      desc: "Chúng tôi cung cấp gạo chất lượng cao đến các thị trường khắp châu Á, Bắc Mỹ, châu Âu, châu Phi và nhiều khu vực khác.",
      cta: "Thị trường của chúng tôi",
      stats: [
        { value: "30+", label: "Quốc gia & Vùng lãnh thổ" },
        { value: "100+", label: "Đối tác tin cậy" },
        { value: "1M+", label: "Tấn cung ứng mỗi năm" },
      ],
    },
    overview: {
      eyebrow: "Mạng lưới của chúng tôi",
      title: "Một chuỗi cung ứng, nhiều thị trường",
      p1: "EverRice kết nối những cánh đồng phù sa màu mỡ của đồng bằng sông Cửu Long với các nhà nhập khẩu, phân phối và bán lẻ trên toàn cầu. Qua hai thập kỷ, chúng tôi đã xây dựng những mối quan hệ lâu dài, biến một đơn hàng đơn lẻ thành một quan hệ đối tác đáng tin cậy.",
      p2: "Từ chứng từ xuất khẩu và giấy chứng nhận chất lượng đến bao bì tùy chỉnh và lịch vận chuyển, đội ngũ của chúng tôi lo mọi chi tiết để kệ hàng của bạn luôn đầy đủ — mùa này sang mùa khác.",
      ctaProducts: "Sản phẩm của chúng tôi",
      ctaQuote: "Yêu cầu báo giá",
      stats: [
        { value: "25+", label: "Thị trường xuất khẩu" },
        { value: "200k", label: "Tấn xuất khẩu mỗi năm" },
        { value: "5", label: "Châu lục được phục vụ" },
        { value: "24h", label: "Thời gian phản hồi báo giá" },
      ],
    },
    map: {
      eyebrow: "Thị trường xuất khẩu",
      title: "Gạo Việt Nam vươn ra Thế giới",
      labels: {
        markets: "Thị trường",
        ofVolume: "Sản lượng",
        growth: "Tăng trưởng",
        keyMarkets: "Thị trường chính",
        viewAria: "Xem dữ liệu xuất khẩu",
      },
      countries: {
        spain: "Tây Ban Nha",
        austria: "Áo",
        dubai: "Dubai",
        ghana: "Ghana",
        russia: "Nga",
        canada: "Canada",
        usa: "Hoa Kỳ",
        china: "Trung Quốc",
        hongkong: "Hồng Kông",
        philippines: "Philippines",
        malaysia: "Malaysia",
        singapore: "Singapore",
        indonesia: "Indonesia",
        australia: "Úc",
        solomon: "Quần đảo Solomon",
      },
      regions: [
        {
          name: "Châu Á",
          tagline: "Thị trường lớn nhất và lâu đời nhất của chúng tôi",
          desc: "Từ Tokyo đến Manila, gạo thơm và gạo trắng của chúng tôi là mặt hàng chủ lực đáng tin cậy trên bàn ăn khắp châu Á — được cung cấp quanh năm theo hợp đồng dài hạn.",
          growth: "+12% so với cùng kỳ",
          volume: "190.000 tấn",
          markets: [
            "Nhật Bản",
            "Philippines",
            "Trung Quốc",
            "Hàn Quốc",
            "Singapore",
            "Malaysia",
          ],
        },
        {
          name: "Trung Đông",
          tagline: "Khu vực đối tác đang phát triển nhanh",
          desc: "Chúng tôi phục vụ khách sạn, nhà bán lẻ và nhà phân phối khắp vùng Vịnh với gạo xay kỹ, đồng nhất, phù hợp khẩu vị khu vực và yêu cầu Halal.",
          growth: "+18% so với cùng kỳ",
          volume: "130.000 tấn",
          markets: ["UAE", "Ả Rập Xê-út", "Qatar", "Kuwait", "Oman"],
        },
        {
          name: "Châu Âu",
          tagline: "Chất lượng cao cấp cho khách hàng khó tính",
          desc: "Các nhà nhập khẩu châu Âu tin tưởng vào chuỗi cung ứng có thể truy xuất, kiểm soát chất lượng nghiêm ngặt và chứng từ đáng tin cậy của chúng tôi cho mỗi container.",
          growth: "+9% so với cùng kỳ",
          volume: "95.000 tấn",
          markets: ["Đức", "Hà Lan", "Ba Lan", "Vương quốc Anh", "Pháp"],
        },
        {
          name: "Châu Phi",
          tagline: "Cùng nhau xây dựng an ninh lương thực",
          desc: "Chúng tôi hỗ trợ các nhà bán buôn và chương trình cứu trợ khắp Tây và Nam Phi với sản lượng đáng tin cậy và lựa chọn đóng gói linh hoạt.",
          growth: "+15% so với cùng kỳ",
          volume: "55.000 tấn",
          markets: ["Ghana", "Bờ Biển Ngà", "Nam Phi"],
        },
        {
          name: "Châu Mỹ",
          tagline: "Mở rộng đến những bến bờ mới",
          desc: "Một thị trường mới hơn của EverRice, phục vụ các nhà bán lẻ và phân phối thực phẩm châu Á khắp Bắc Mỹ với các giống gạo Việt Nam chính gốc.",
          growth: "+21% so với cùng kỳ",
          volume: "30.000 tấn",
          markets: ["Hoa Kỳ", "Canada"],
        },
      ],
    },
    regionStats: {
      eyebrow: "Qua những con số",
      title: "Quy Mô và Năng Lực",
      sub: "Sản lượng xuất khẩu tham khảo hằng năm tại 5 thị trường trọng điểm.",
      marketsUnit: "thị trường đích",
      shareUnit: "tổng lượng xuất khẩu",
    },
    keyMarkets: {
      eyebrow: "Điểm đến chính",
      title: "Được khách hàng toàn cầu tin tưởng",
      items: [
        {
          country: "Philippines",
          region: "Châu Á",
          note: "Khách hàng mua số lượng lớn gạo thơm và gạo trắng. Có lựa chọn xếp hàng bằng container và tàu rời.",
        },
        {
          country: "Trung Quốc",
          region: "Châu Á",
          note: "Khách hàng mua số lượng lớn gạo thơm và gạo nếp. Chủ yếu cung ứng bằng hình thức đóng container.",
        },
        {
          country: "Singapore",
          region: "Châu Á",
          note: "Trung tâm giao thương khu vực cho phân phối thực phẩm, bán buôn và dịch vụ ăn uống.",
        },
        {
          country: "Hồng Kông",
          region: "Châu Á",
          note: "Thị trường cao cấp cho gạo thơm và gạo chuẩn sushi.",
        },
      ],
    },
    logistics: {
      eyebrow: "Từ cánh đồng đến bến cảng",
      title: "Tối ưu Logistic, đơn giản hóa quy trình",
      items: [
        {
          title: "Thu mua & xay xát",
          desc: "Chúng tôi thu mua lúa từ những cánh đồng của các đối tác đáng tin cậy và xay xát tại các cơ sở hiện đại, được kiểm soát chất lượng nghiêm ngặt.",
        },
        {
          title: "Kiểm định chất lượng",
          desc: "Mỗi lô đều được kiểm nghiệm độ ẩm, hạt gãy và độ tinh khiết trước khi phê duyệt.",
        },
        {
          title: "Đóng gói & xếp hàng",
          desc: "Bao bì hoặc container số lượng lớn được đóng gói và lên pallet theo đúng quy cách của bạn.",
        },
        {
          title: "Vận tải đường biển",
          desc: "Vận chuyển qua các cảng lớn của Việt Nam với đầy đủ chứng từ xuất khẩu.",
        },
        {
          title: "Giao hàng & hỗ trợ",
          desc: "Giao hàng đúng hạn đến cảng đích, với sự đồng hành của chuyên viên phụ trách riêng.",
        },
      ],
    },
    compliance: {
      eyebrow: "Sẵn sàng xuất khẩu",
      title: "Hồ Sơ Đầy Đủ, Thủ Tục Trọn Vẹn",
      desc: "Từ hồ sơ xuất khẩu và chứng nhận chất lượng đến bao bì theo yêu cầu và lịch vận chuyển, đội ngũ của chúng tôi xử lý mọi chi tiết để lô hàng của bạn được thông quan thuận lợi, không chậm trễ.",
      items: [
        {
          title: "HACCP & ISO 22000",
          desc: "Quản lý an toàn thực phẩm xuyên suốt hoạt động xay xát của chúng tôi.",
        },
        {
          title: "Giấy kiểm dịch thực vật",
          desc: "Giấy kiểm dịch thực vật chính thức được cấp cho mỗi lô xuất khẩu.",
        },
        {
          title: "Giấy chứng nhận xuất xứ",
          desc: "Chứng từ đầy đủ xác nhận xuất xứ Việt Nam cho hải quan.",
        },
        {
          title: "Tùy chọn Halal & Kosher",
          desc: "Có sẵn quy trình đạt chuẩn cho Trung Đông và các khách hàng khác.",
        },
      ],
    },
    cta: {
      title: "Đưa Gạo Chất Lượng Đến Thị Trường Của Bạn",
      desc: "Cung cấp cảng đến, sản lượng và quy cách đóng gói mong muốn. Đội ngũ EverRice sẽ gửi báo giá phù hợp trong vòng một ngày làm việc.",
      ctaContact: "Liên hệ kinh doanh",
      ctaQuality: "Chất lượng của chúng tôi",
    },
  },
  contactPage: {
    hero: {
      eyebrow: "LIÊN HỆ",
      title: "Kết nối với chúng tôi",
      desc: "Dù bạn cần báo giá, mẫu sản phẩm hay một đối tác cung ứng lâu dài, đội ngũ xuất khẩu của chúng tôi luôn sẵn sàng hỗ trợ.",
    },
    main: {
      eyebrow: "Kết nối với chúng tôi",
      title:
        "Chúng tôi luôn sẵn sàng lắng nghe và mong muốn được đồng hành cùng bạn.",
      desc: "Hãy liên hệ qua biểu mẫu hoặc thông tin bên dưới. Các chuyên viên xuất khẩu của chúng tôi phản hồi mọi yêu cầu trong vòng một ngày làm việc.",
      info: [
        {
          label: "Địa chỉ",
          value:
            "The Everrich, 968 Đường 3/2, Phường Phú Thọ, TP. Hồ Chí Minh, Việt Nam",
        },
        { label: "Email", value: "info@everrice.vn" },
        { label: "Điện thoại", value: "+84 918335899" },
        {
          label: "Giờ làm việc",
          value: "Thứ Hai – Thứ Bảy, 8:00 – 17:00 (GMT+7)",
        },
      ],
      ctaProducts: "Xem sản phẩm",
      ctaReach: "Thị trường",
    },
    form: {
      title: "Gửi tin nhắn cho chúng tôi",
      note: "Các trường có dấu * là bắt buộc.",
      name: "Họ tên",
      namePh: "Họ tên đầy đủ của bạn",
      email: "Email",
      emailPh: "ban@congty.com",
      phone: "Điện thoại",
      phonePh: "+84 ...",
      message: "Nội dung",
      messagePh:
        "Cho chúng tôi biết thị trường đến, sản lượng và nhu cầu đóng gói của bạn...",
      submit: "Gửi tin nhắn",
      sending: "Đang gửi...",
      success:
        "Cảm ơn bạn! Tin nhắn đã được gửi — chúng tôi sẽ phản hồi trong thời gian sớm nhất.",
      errorDefault:
        "Chúng tôi không thể gửi tin nhắn của bạn. Vui lòng thử lại.",
      network:
        "Đã xảy ra lỗi kết nối. Vui lòng kiểm tra kết nối mạng và thử lại.",
      extraLabel: "Thông tin thêm",
    },
    map: {
      eyebrow: "Tìm chúng tôi",
      title: "Chào mừng đến với EverRice",
    },
  },
};
